const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnlink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2811 11.5156C15.0802 11.5156 14.8794 11.4458 14.7264 11.3067C14.4195 11.0278 14.4195 10.577 14.7264 10.2981L16.3112 8.85733C17.0339 8.2068 17.4308 7.33803 17.4308 6.40866C17.4308 4.49781 15.7204 2.9422 13.6177 2.9422C12.5962 2.9422 11.6405 3.30306 10.9267 3.9579L9.33939 5.4008C9.03267 5.67977 8.53675 5.67977 8.23004 5.4008C7.92332 5.12196 7.92332 4.67112 8.23004 4.39228L9.8149 2.95082C10.8238 2.02641 12.175 1.51562 13.6177 1.51562C16.5858 1.51562 19 3.71041 19 6.40866C19 7.72174 18.4381 8.94928 17.4174 9.86872L15.835 11.3067C15.682 11.4458 15.4819 11.5156 15.2811 11.5156Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38225 18.5156C4.41422 18.5156 2 16.1014 2 13.1334C2 11.689 2.56186 10.3387 3.58257 9.32737L5.16499 7.74566C5.47185 7.43895 5.96762 7.43895 6.27448 7.74566C6.5812 8.05238 6.5812 8.54829 6.27448 8.85501L4.68962 10.4399C3.96614 11.1555 3.56921 12.1111 3.56921 13.1334C3.56921 15.2353 5.27963 16.9464 7.38225 16.9464C8.40382 16.9464 9.35946 16.5495 10.0733 15.8292L11.6606 14.242C11.9673 13.9351 12.4632 13.9351 12.77 14.242C13.0767 14.5487 13.0767 15.0446 12.77 15.3514L11.1851 16.9371C10.1762 17.9538 8.82518 18.5156 7.38225 18.5156Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7732 8.51562C11.5753 8.51562 11.3774 8.43989 11.2267 8.28911C10.9244 7.98686 10.9244 7.49816 11.2267 7.19591L12.6801 5.74242C12.9824 5.44003 13.471 5.44003 13.7733 5.74242C14.0756 6.04467 14.0756 6.53337 13.7733 6.83562L12.3198 8.28911C12.169 8.43989 11.9711 8.51562 11.7732 8.51562Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77332 13.5156C7.57543 13.5156 7.37739 13.4399 7.22677 13.2891C6.92441 12.9867 6.92441 12.4982 7.22677 12.1958L8.68013 10.7423C8.98235 10.4401 9.471 10.4401 9.77323 10.7423C10.0756 11.0446 10.0756 11.5333 9.77323 11.8355L8.31987 13.2891C8.16911 13.4399 7.97122 13.5156 7.77332 13.5156Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.227 18.5156C18.0292 18.5156 17.8314 18.4399 17.6807 18.2892L2.22666 2.83486C1.92445 2.53279 1.92445 2.04437 2.22666 1.74229C2.52874 1.44007 3.01701 1.44007 3.31923 1.74229L18.7734 17.1965C19.0755 17.4987 19.0755 17.987 18.7734 18.2892C18.6228 18.4399 18.4248 18.5156 18.227 18.5156Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlink);
export default __webpack_public_path__ + "static/media/icon_unlink.0fe416afb261896e5f562312d3ead1b2.svg";
export { ForwardRef as ReactComponent };